import React from "react";
import { useHistory } from "react-router-dom";
import { Pagebar } from "../layout/Pagebar";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useClaimCalander } from "./Calandar.hook";
import { FullPageSpinner } from "../_common/Spinner";

import "./Calendar.css";

export function Calendar() {
  let history = useHistory();
  const {
    allEvents,
    isLoading,
    getMyReminders,
    getReminders,
    initalLoading,
  } = useClaimCalander();

  const handleDateSelect = (selectInfo) => {
    console.log(selectInfo);
  };
  const handleEventClick = (clickInfo) => {
    const clientId = clickInfo.event.extendedProps?.client?.id ?? "";
    history.push(`claims/${clientId}`);
  };
  const handleEvents = () => {};

  const breadcrumb = [
    {
      title: "Home",
      link: "/app/claims",
    },
    {
      title: "Appointments",
      link: "",
    },
  ];

  const renderEventContent = (eventInfo) => {
    const clientName = eventInfo.event.extendedProps?.client?.name ?? "";
    return (
      <>
        <div className="event">
          <div className="event-info">
            <div className="event-title">{eventInfo.event.title}</div>
            <div className="event-client">{clientName}</div>
          </div>

          <div className="event-time">
            <b>{eventInfo.timeText}</b>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      {isLoading && <FullPageSpinner />}
      {<Pagebar breadcrumbs={breadcrumb} />}
      {!initalLoading && (
        <div className="portlet light portlet-fit portlet-datatable bordered">
          <div className="portlet-title">
            <div className="caption">
              <i className="fa fa-calendar"></i>
              <span className="caption-subject font-dark sbold uppercase">
                Appointments
              </span>
            </div>
            <div className="actions">
              <button
                className="btn blue-primary btn-outline  margin-right-10"
                onClick={() => getMyReminders()}
              >
                Export My Reminders
              </button>
              <button
                className="btn blue-primary btn-outline  margin-right-10"
                onClick={() => getReminders()}
              >
                Export All Reminders
              </button>
            </div>
          </div>
          <div className="portlet-body">
            <div className="row">
              <div className="col-lg-12 col-xs-12 col-sm-12">
                <div className="portlet light calendar bordered">
                  <div className="portlet-title ">
                    <div className="caption">
                      <i className="icon-calendar font-dark hide"></i>
                      <span className="caption-subject font-dark bold uppercase">
                        Calendar View
                      </span>
                    </div>
                  </div>
                  <div className="portlet-body">
                    <div>

                      <FullCalendar
                        timeZone = {'local'}
                        plugins={[
                          dayGridPlugin,
                          timeGridPlugin,
                          interactionPlugin,
                        ]}
                        headerToolbar={{
                          left: "",
                          center: "title",
                          right:
                            "prev,next today, dayGridMonth,timeGridWeek,timeGridDay",
                        }}
                        initialView="dayGridMonth"
                        editable={true}
                        selectable={false}
                        selectMirror
                        dayMaxEvents
                        weekends={true}
                        initialEvents={allEvents}
                        select={handleDateSelect}
                        eventContent={renderEventContent}
                        eventClick={handleEventClick}
                        eventsSet={handleEvents}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
